import React from 'react';
import { Box, makeStyles, CircularProgress } from '@material-ui/core';
import SpeedIcon from '@material-ui/icons/Speed';
import StarIcon from '@material-ui/icons/Star';
import GroupIcon from '@material-ui/icons/Group';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import { HomeCard } from './HomeCard';
import { StatMetric } from './StatMetric';

const useStyles = makeStyles(theme => ({
  metricsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: theme.spacing(3),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 120,
  },
}));

type PlatformSnapshotCardProps = {
  uptime?: number | null;
  uptimeLoading?: boolean;
  maturity?: number | null;
  maturityLoading?: boolean;
  totalMembers?: number | null;
  membersLoading?: boolean;
  totalSystems?: number | null;
  systemsLoading?: boolean;
  showSystems?: boolean;
  showMembers?: boolean;
  actionHref?: string;
};

export const PlatformSnapshotCard = ({
  uptime,
  uptimeLoading = false,
  maturity,
  maturityLoading = false,
  totalMembers,
  membersLoading = false,
  totalSystems,
  systemsLoading = false,
  showSystems = false,
  showMembers = true,
  actionHref = '/gatus-monitor',
}: PlatformSnapshotCardProps) => {
  const classes = useStyles();

  const allLoading =
    uptimeLoading &&
    maturityLoading &&
    (showMembers ? membersLoading : true) &&
    (showSystems ? systemsLoading : true);

  return (
    <HomeCard
      title="Platform Snapshot"
      actionLabel="View Details"
      actionHref={actionHref}
      fitContent
    >
      {allLoading ? (
        <Box className={classes.loadingContainer}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box className={classes.metricsGrid}>
          <StatMetric
            value={
              uptimeLoading
                ? '...'
                : uptime !== null && uptime !== undefined
                ? `${uptime}%`
                : 'N/A'
            }
            label="Overall Uptime"
            sublabel="last 7 days"
            icon={<SpeedIcon />}
            iconBgColor="rgba(34, 197, 94, 0.09)"
            iconColor="#22C55E"
          />
          {showSystems && (
            <StatMetric
              value={
                systemsLoading
                  ? '...'
                  : totalSystems !== null && totalSystems !== undefined
                  ? totalSystems
                  : 'N/A'
              }
              label="Total Systems"
              sublabel="registered systems"
              icon={<AccountTreeIcon />}
              iconBgColor="rgba(82, 146, 244, 0.09)"
              iconColor="#5292F4"
            />
          )}
          <StatMetric
            value={
              maturityLoading
                ? '...'
                : maturity !== null && maturity !== undefined
                ? maturity.toFixed(1)
                : 'N/A'
            }
            label="Avg Maturity Score"
            sublabel="across components"
            icon={<StarIcon />}
            iconBgColor="rgba(240, 163, 28, 0.09)"
            iconColor="#F0A31C"
          />
          {showMembers && (
            <StatMetric
              value={
                membersLoading
                  ? '...'
                  : totalMembers !== null && totalMembers !== undefined
                  ? totalMembers
                  : 'N/A'
              }
              label="Total Members"
              sublabel="active users"
              icon={<GroupIcon />}
              iconBgColor="rgba(168, 85, 247, 0.09)"
              iconColor="#A855F7"
            />
          )}
        </Box>
      )}
    </HomeCard>
  );
};
